import { UpsellBannerContent } from '../components/UpsellBanner';
import { spartanStrings } from './spartanStrings';
import { nonWin10_IE_Strings, nonWin10_NonIE_Strings, macStrings } from './nonWin10Strings';
import { win10_IE_Strings, win10_NonIE_Strings } from './win10Strings';
import { isWin10, isBrowserIE, isMac, isBrowserEdge } from 'owa-user-agent';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function getUpsellStrings(): UpsellBannerContent[] {
    const userConfiguration = getUserConfiguration();
    let upsellStrings: UpsellBannerContent[];

    if (isMac()) {
        upsellStrings = macStrings;
    } else if (isBrowserEdge()) {
        upsellStrings = spartanStrings;
    } else if (isWin10()) {
        if (isBrowserIE()) {
            upsellStrings = win10_IE_Strings;
        } else {
            upsellStrings = win10_NonIE_Strings;
        }
    } else {
        if (isBrowserIE()) {
            upsellStrings = nonWin10_IE_Strings;
        } else {
            upsellStrings = nonWin10_NonIE_Strings;
        }
    }

    if (userConfiguration.SessionSettings?.UserCulture?.toLowerCase() != 'en-us') {
        upsellStrings = upsellStrings.filter(str => str.isEnUsOnly == undefined);
    }

    return upsellStrings;
}
